import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  ViewEncapsulation,
  Input,
  ComponentRef
} from '@angular/core';
import * as moment from 'moment';
import { ToasterService } from 'src/app/services/toaster.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { HotelService } from '../../../services/hotel.service';
import { SearchCriteria } from 'src/app/model/hotel.model';
import { RoomComponent } from 'src/app/shared-components/traveller-count-picker/room/room.component';
import { CalendarComponent } from 'src/app/shared-components/calendar/calendar.component';
import { AutosuggestPopupComponent } from 'src/app/shared-components/autosuggest-popup/autosuggest-popup/autosuggest-popup.component';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { AppContext, UrlState } from 'src/app/services/app-context.service';
import { TOPDestinations } from 'src/app/services/topdestinations.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import countrycodes from 'src/app/pages/checkout/utils/nationality.json';
import { DataLayerEvent } from 'types';
import { SiteContext } from 'src/app/model';
import { StorageService } from 'src/app/services/storage.service';
import { Location } from '@angular/common';
import Constants from '../../checkout/utils/Constants';
import { Subscription } from 'rxjs';

declare const gtag: Function;
@Component({
  selector: 'travel-ui-search-hotels',
  templateUrl: './search-hotels.component.html',
  styleUrls: ['./search-hotels.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchHotelsComponent implements OnInit {
  @Input() submitBtnDisabled = false;
  calendarConfig: any = {
    twoMonthView: true,
    selectionStartDate: null,
    selectionEndDate: null,
    rangeSelectionType: true,
    maxSelectionRange: 90,
    preSelectedRange: 3,
    isHandset: false,
    isDisabledBefore: null,
    isHistoricalDatePicker: false
  };
  public nationalityAndCountryOfResidence = {
    nationality: '',
    countryOfResidence: ''
  };
  errorText = '';
  showError = false;

  // @Input()
  roomDisplayOptions = [
    {
      label: 'Room 1',
      passangerTypes: [
        {
          type: 'Adults',
          subtitle: 'Above 12 years',
          count: 2,
          ageArray: [],
          minValue: 1
        },
        {
          type: 'Children',
          subtitle: 'Below 12 years',
          count: 0,
          ageArray: [],
          minValue: 0
        }
      ]
    }
  ];
  // @Input()
  locationOption: any = {};
  @Input() enableSearchBox: boolean = true;
  siteName: string | undefined;

  countryList: {
    name: string;
    code: string;
  }[] = countrycodes.countrycodes;

  nationality!: string;
  countryOfResidence!: string;
  defaultNationality!: string;
  defaultcountryOfResidence!: string;

  @Input()
  set setAutoSuggestOptions(options: any) {
    this.autosuggestOptions = options;
    this.showAutosuggestLoader = false;
    if (this.componentRef) {
      this.componentRef.instance.options = this.autosuggestOptions;
    }
  }

  @Output() getSearchOptions: EventEmitter<any> = new EventEmitter();
  @Output() submit: EventEmitter<any> = new EventEmitter();
  @Output() searchRate: EventEmitter<any> = new EventEmitter();

  isDatePickerOpened = false;
  isRoomPickerOpened = false;

  @ViewChild('roomPicker', { read: ElementRef, static: true })
  roomPicker!: ElementRef;
  @ViewChild('datePicker', { read: ElementRef, static: true })
  datePicker!: ElementRef;
  @ViewChild('autosuggest', { read: ElementRef, static: true })
  autosuggest!: ElementRef;

  startDate: any;
  endDate: any;
  isOpened = false;
  searchCriteria = {};
  isHandset = false;
  portal!: ComponentPortal<any>;
  showAutosuggestLoader = false;

  criteria?: SearchCriteria;
  room: any[] = [];

  passengerCount = {
    Adults: 0,
    Children: 0,
    Rooms: 0
  };

  typeAndIconMapping: any = {
    city: 'fa-map-marker',
    pointOfInterest: 'fa-map-marker',
    hotel: 'fa-hotel',
    airport: 'fa-plane',
    state: 'fa-map-marker',
    multiCity: 'fa-map-marker',
    trainStation: 'fa-train'
  };

  autosuggestOptions: any;
  overlayRef: any;
  componentRef: any;
  displaySetting: any;
  private routerEventsSubscription: Subscription = new Subscription();

  searchStr = '';
  public advanceSearch: boolean = false;
  public pnrNumber!: string;
  tagManagerId: string = '';
  urlState: UrlState = { currentUrl: '', flag: false };
  defaultLongDateFormat: string = "";
  defaultShortDateFormat: string = "MM/DD/YYYY"
  isHomePage: boolean = false;

  constructor(
    public auth: AuthService,
    private overlay: Overlay,
    private toasterSvc: ToasterService,
    private breakpointObserver: BreakpointObserver,
    public hotelService: HotelService,
    public appContext: AppContext,
    public topdestinations: TOPDestinations,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private storage: StorageService
  ) {
    const str = JSON.parse(sessionStorage.getItem('SiteContext') || '{}');
    this.siteName = str.name;
    this.tagManagerId = str?.displaySetting?.googleAnalyticsCode;
    this.countryList = countrycodes.countrycodes;
    const nation = JSON.parse(
      sessionStorage.getItem('NationAndResidency') || '{}'
    );
    this.nationality = nation.nationality;
    this.countryOfResidence = nation.countryOfResidence;
    if (
      this.appContext.siteName != 'HostMyTrips') {
      this.nationality = 'US';
      this.countryOfResidence = 'US';
      environment.countryOfResidence = this.countryOfResidence;
      environment.nationality = this.nationality;
    }

    if (this.appContext.siteName == 'HostMyTrips') {
      this.nationality = 'IN';
      this.countryOfResidence = 'IN';
      environment.countryOfResidence = this.countryOfResidence;
      environment.nationality = this.nationality;
    }
    if (this.appContext.siteName == '30Sundays') {
      this.nationality = 'IN';
      this.countryOfResidence = 'IN';
      environment.countryOfResidence = this.countryOfResidence;
      environment.nationality = this.nationality;
    }
    if (this.appContext.siteName == 'onyxum') {
      this.nationality = 'AM';
      this.countryOfResidence = 'AM';
      environment.countryOfResidence = this.countryOfResidence;
      environment.nationality = this.nationality;
    }
    this.onChangeNationality();
    this.appContext.urlState$.subscribe((state: UrlState) => {
      this.urlState = state;
      if (this.urlState.flag && this.urlState.currentUrl.includes('results')) {
        this.submitSearch();
      }
    });
    this.appContext.siteContext$.subscribe((context: SiteContext | null) => {
      if (
        this.nationality === 'IN' ||
        this.appContext.siteName == 'ShamalGroup'
      ) {
        this.defaultLongDateFormat = 'dd DD/MM/YY';
      } else {
        this.defaultLongDateFormat = 'dd MM/DD/YY';
      }
    })
  }

  private checkIfHomePage(): void {
    // Check current URL
    this.isHomePage = this.isHomeRoute(this.router.url);
    this.updateSearchWrapperStyling();

    // Subscribe to route changes
   this.routerEventsSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isHomePage = this.isHomeRoute(event.url);
        this.updateSearchWrapperStyling();
      }
    });
  }

  private updateSearchWrapperStyling(): void {
    const resultWrapper = document.getElementById('resultSearchWrapper');
    if (resultWrapper) {
      if (!this.isHomePage) {
        resultWrapper.classList.add('bg-wrapper');
      } else {
        resultWrapper.classList.remove('bg-wrapper');
      }
    }
  }

  private isHomeRoute(url: string): boolean {
    // Check for exact home route or home route with query parameters
    const cleanUrl = url.split('?')[0]; // Remove query parameters
    return cleanUrl === '/' || cleanUrl === '' || cleanUrl === '/home';
  }

  ngOnInit() {
    this.displaySetting = JSON.parse(
      sessionStorage.getItem('SiteContext') as string
    )?.displaySetting;

    // Check if we're on the home page
    this.checkIfHomePage();

    let searchIdFromUrl = this.route.snapshot.queryParamMap.get('searchid');
    if (searchIdFromUrl != null) {
      let storedCriteria = localStorage.getItem(
        searchIdFromUrl + '_searchCriteria'
      );
      if (storedCriteria != null) {
        let searchCriteria = JSON.parse(storedCriteria);
        this.hotelService.searchCriteria = searchCriteria;
      }
      console.debug('ishome',this.isHomePage)
      // Apply styling based on home page status
      this.updateSearchWrapperStyling();
    }
    this.criteria = this.hotelService.searchCriteria;
    this.locationOption.fullName = this.criteria.fullName;
    this.locationOption.id = this.criteria.locationId;
    this.locationOption.referenceId = this.criteria.referenceId;

    this.breakpointObserver.observe(Breakpoints.Handset).subscribe((result) => {
      // if (result.matches) {
      this.isHandset = result.matches;
      this.calendarConfig.isHandset = this.isHandset;
      // }
    });

    if (!this.criteria?.checkIn) {
      // if (!this.calendarConfig.selectionStartDate) {
      this.calendarConfig.selectionStartDate = { date: new Date() };
    } else {

      this.calendarConfig.selectionStartDate = {
        date: moment(
          this.criteria.checkIn,
          this.defaultShortDateFormat
        ).toDate()
      };

    }
    if (!this.criteria?.checkOut) {
      this.calendarConfig.selectionEndDate = {
        date: new Date(
          new Date().setDate(
            new Date().getDate() + this.calendarConfig.preSelectedRange - 1
          )
        )
      };
    } else {
      this.calendarConfig.selectionEndDate = {
        date: moment(
          this.criteria.checkOut,
          this.defaultShortDateFormat
        ).toDate()
      };

    }

    this.formatDate();
    this.room = this.criteria.rooms;
    this.formatRoomSummary(this.room);
  }

  // advanceSearchButton
  advancSearch() {
    this.advanceSearch = true;
  }

  onChangeNationality() {
    environment.countryOfResidence = this.countryOfResidence;
    environment.nationality = this.nationality;
    this.nationalityAndCountryOfResidence.countryOfResidence =
      environment.countryOfResidence;
    this.nationalityAndCountryOfResidence.nationality = environment.nationality;
    sessionStorage.setItem(
      'NationAndResidency',
      JSON.stringify(this.nationalityAndCountryOfResidence)
    );
  }

  /** Toggle Room picker state - show / hide overlay */
  toggleRoomPicker() {
    const config = new OverlayConfig();
    let strategy;
    if (this.isHandset) {
      strategy = this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically();
      config.scrollStrategy = this.overlay.scrollStrategies.block();
      config.height = '100%';
      config.width = '100%';
    } else {
      strategy = this.overlay
        .position()
        .flexibleConnectedTo(this.roomPicker.nativeElement)
        .withPush(false);

      strategy.withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        }
      ]);

      config.scrollStrategy = this.overlay.scrollStrategies.reposition();
      // config.width = '500px';
    }

    config.hasBackdrop = true;
    config.backdropClass = 'cdk-overlay-custom-backdrop';
    config.positionStrategy = strategy;

    this.portal = new ComponentPortal(RoomComponent);
    const overlayRef = this.overlay.create(config);
    const componentRef = overlayRef.attach(this.portal);

    componentRef.instance.presetRoomsPassengers = this.roomDisplayOptions;
    componentRef.instance.mobileView = this.isHandset;

    componentRef.instance.close.subscribe((res: any) => {
      overlayRef.dispose();
    });

    componentRef.instance.done.subscribe((res: any) => {
      this.formatRoomSummary(res);
      overlayRef.dispose();
    });

    overlayRef.backdropClick().subscribe(() => {
      // this.datesSelected();
      overlayRef.dispose();
    });
  }

  /** Toggle Date picker state - show / hide overlay */
  toggleDatePicker() {
    const config = new OverlayConfig();
    let strategy;
    if (this.isHandset) {
      strategy = this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically();
      config.scrollStrategy = this.overlay.scrollStrategies.block();
      config.height = '100%';
    } else {
      strategy = this.overlay
        .position()
        .flexibleConnectedTo(this.datePicker.nativeElement)
        .withPush(false);

      strategy.withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        }
      ]);

      config.scrollStrategy = this.overlay.scrollStrategies.reposition();
      config.width = '700px';
    }

    config.hasBackdrop = true;
    config.backdropClass = 'cdk-overlay-custom-backdrop';
    config.positionStrategy = strategy;

    this.portal = new ComponentPortal(CalendarComponent);
    const overlayRef = this.overlay.create(config);
    const componentRef = overlayRef.attach(this.portal);
    componentRef.instance.calendarConfig = this.calendarConfig;

    componentRef.instance.datesSelected.subscribe((res: any) => {
      this.datesSelected();
      overlayRef.dispose();
    });

    overlayRef.backdropClick().subscribe(() => {
      if (
        componentRef.instance.calendarConfig.selectionStartDate &&
        componentRef.instance.calendarConfig.selectionEndDate
      ) {
        this.datesSelected();
        overlayRef.dispose();
      }
    });
  }

  toggleAutosuggestDesktop() {
    this.getDefaultAutoSuggestOptions();
    this.isOpened = true;
  }

  /** Toggle Date picker state - show / hide overlay */
  toggleAutosuggest() {
    this.getDefaultAutoSuggestOptions();
    const config = new OverlayConfig();
    let strategy;
    if (this.isHandset) {
      strategy = this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically();
      config.scrollStrategy = this.overlay.scrollStrategies.block();
      config.height = '100%';
      config.width = '100%';
    } else {
      strategy = this.overlay
        .position()
        .flexibleConnectedTo(this.autosuggest.nativeElement)
        .withPush(false);

      strategy.withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        }
      ]);

      config.scrollStrategy = this.overlay.scrollStrategies.reposition();
      config.width = '500px';
    }

    config.hasBackdrop = true;
    config.backdropClass = 'cdk-overlay-custom-backdrop';
    config.positionStrategy = strategy;

    this.portal = new ComponentPortal(AutosuggestPopupComponent);
    this.overlayRef = this.overlay.create(config);
    this.componentRef = this.overlayRef.attach(this.portal);

    this.componentRef.instance.options = this.autosuggestOptions;
    this.componentRef.instance.preselectedOption = this.locationOption.fullName;

    this.componentRef.instance.close.subscribe((res: any) => {
      this.overlayRef.dispose();
      this.autosuggestOptions = [];
    });
    this.componentRef.instance.optionselected.subscribe((res: any) => {
      this.locationOption = res;
      this.overlayRef.dispose();
      this.autosuggestOptions = [];
      this.toggleDatePicker();
    });
    this.componentRef.instance.searchString.subscribe((res: any) => {
      this.setIsOpenedFlag(res);
    });

    this.overlayRef.backdropClick().subscribe(() => {
      if (
        this.componentRef.instance.calendarConfig.selectionStartDate &&
        this.componentRef.instance.calendarConfig.selectionEndDate
      ) {
        this.datesSelected();
        this.overlayRef.dispose();
      }
    });

    this.componentRef.instance.close.subscribe((res: any) => {
      this.overlayRef.dispose();
      this.autosuggestOptions = [];
    });
  }

  /** Format Room summary to be shown on search box */
  formatRoomSummary(rooms: any) {
    this.passengerCount = {
      Adults: 0,
      Children: 0,
      Rooms: 0
    };
    /*  rooms.forEach(room => {
        room.passangerTypes.forEach(passangerType => {
          if (this.passengerCount.hasOwnProperty(passangerType.type)) {
            this.passengerCount[passangerType.type] += passangerType.count;
          } else {
            this.passengerCount[passangerType.type] = passangerType.count;
          }
        });
      });*/
    rooms.forEach((room: any) => {
      this.passengerCount.Adults += room.adults;
      this.passengerCount.Children += room.children || 0;
    });
    this.passengerCount['Rooms'] = rooms.length;
    this.roomDisplayOptions = rooms;
  }

  /** on submit seach button click */
  submitSearch() {
    const loginRequired = [
      'Prestigate',
      'NobleStay',
      'DevDemo',
      'ShamalGroup-B2B',
      'ViaReel',
      'SecretEscapades',
      '30Sundays'
    ];

    if (
      !loginRequired.includes(this.appContext.pageTitlePrefix) ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'Prestigate') ||
       (this.auth.isLoggedIn && this.appContext.siteName == '30Sundays') ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'NobleStay') ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'DevDemo') ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'SecretEscapades') ||
      (this.auth.isLoggedIn &&
        this.displaySetting.pageTitlePrefix === 'ShamalGroup-B2B') ||
      (this.auth.isLoggedIn && this.displaySetting.pageTitlePrefix === 'ViaReel')
    ) {
      try {
        /** This not working on OLD chrome browser. */
        if (this.appContext?.siteName !== "BookMyGetaway" &&
          this.appContext?.siteName !== "BookMyGataway") {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      } catch { }
      this.createSearchCriteria();
      this.storage.setUrl(this.location.path());
      if (this.enableSearchBox) {
        this.submit.emit({
          searchSelectedOption: this.locationOption,
          searchCriteria: this.searchCriteria
        });
      } else {
        this.searchRate.emit({
          searchSelectedOption: this.locationOption,
          searchCriteria: this.searchCriteria
        });
      }
      if (this.tagManagerId) {
        gtag('event', 'view_item_list', {
          'value': JSON.stringify(this.searchCriteria)
        });
      }
    } else {
      this.toasterSvc.error('Please make sure you are logged in.');
    }
  }

  dispalyError(message: string): void {
    this.errorText = message;
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 10000);
  }

  /** Create required search criteria */
  createSearchCriteria() {
    this.searchCriteria = Object.assign(this.searchCriteria, {
      culture: 'en-us',
      // currency: 'USD',
      checkIn: moment(this.calendarConfig.selectionStartDate.date).format(
        this.defaultShortDateFormat
      ),
      checkOut: moment(this.calendarConfig.selectionEndDate.date).format(
        this.defaultShortDateFormat
      ),
      rooms: this.getRoomsConfig(),
      countryOfResidence: environment.countryOfResidence,
      nationality: environment.nationality,
      locationId: this.locationOption.id,
      referenceId: this.locationOption.referenceId,
      fullName: this.locationOption.fullName
    });
  }

  /** Create room config as required in search criteria */
  getRoomsConfig() {
    const roomConfig: any[] = [];
    this.roomDisplayOptions.forEach((room: any) => {
      roomConfig.push({
        adults: room.adults, //room.passangerTypes[0].count,
        children: room.children, //room.passangerTypes[1].count,
        childAges: room.childAges //room.passangerTypes[1].ageArray
      });
    });
    return roomConfig;
  }

  /** On selecting date from date picker */
  datesSelected() {
    this.formatDate();
  }

  getDefaultAutoSuggestOptions() {
    this.hotelService
      .getAutoSuggestPopularDestionations()
      .subscribe((res: any) => {
        this.autosuggestOptions = res['locations'];
        if (this.appContext.siteName == 'TravelBrands') {
          this.autosuggestOptions = this.topdestinations.popularCanadaLocations;
        }
        if (this.appContext.siteAccountId == 'avolar-live-account') {
          this.autosuggestOptions = this.topdestinations.popularAvolarLocations;
        }

        if (this.isHandset) {
          this.componentRef.instance.options = this.autosuggestOptions;
        }
      });
  }

  /** Format dates in required format */
  formatDate() {

    if (this.calendarConfig.selectionStartDate && this.defaultLongDateFormat) {
      setTimeout(() => {
        if (
          this.appContext.siteName == 'ShamalGroup' ||
          this.nationality === 'IN' || this.nationality === 'UK' ||
          this.appContext.siteName == "HostMyTrips" || this.appContext?.siteName == 'Hotelusso' || this.appContext?.siteName == 'BookMyGetaway' ||
          this.appContext?.siteName == 'BookMyGataway' || this.appContext.siteName == Constants.SiteNames.roomantic
        ) {
          this.startDate = moment(
            this.calendarConfig.selectionStartDate.date
          ).format('dd DD/MM/YY');

          this.endDate = moment(
            this.calendarConfig.selectionEndDate.date
          ).format('dd DD/MM/YY');
        } else if (this.appContext.siteName == 'Sharecare') {
          this.startDate = moment(
            this.calendarConfig.selectionStartDate.date
          ).format('dd MMM DD, YYYY');
          this.endDate = moment(
            this.calendarConfig.selectionEndDate.date
          ).format('dd MMM DD, YYYY');
        }

        else {
          this.startDate = moment(
            this.calendarConfig.selectionStartDate.date
          ).format('dd MM/DD/YY');
          this.endDate = moment(
            this.calendarConfig.selectionEndDate.date
          ).format('dd MM/DD/YY');
        }
      }, 500);
    } else {
      this.startDate = '-';
    }
  }

  /** Set state of autosuggest */
  setIsOpenedFlag(event: any) {
    this.isOpened = true;
    this.searchStr = event.searchStr;
    this.showAutosuggestLoader = true;
    this.getSearchOptions.emit(this.searchStr);
    // this.hotelService.getAutosuggestOptions(this.searchStr).subscribe((res: any) => {
    //   this.autosuggestOptions = res['locations'];
    //   this.showAutosuggestLoader = false;
    // });
  }

  getClickedOption(option: any) {
    this.locationOption = option;
    this.isOpened = false;

    // Opening date picker once option is selected
    this.toggleDatePicker();
  }
  ngOnDestroy(): void {
     this.routerEventsSubscription?.unsubscribe();
   }
}
